import type { SerializeFrom } from '~/utils/serialize-from'
import type { loader } from '~/root'

/**
 * This is a proxy which will use window.ENV when available and otherwise will use process.env
 */
export const ENV = new Proxy(
  {},
  {
    get(target, p) {
      return typeof window !== 'undefined' ? window.ENV[p as string] : process.env[p as string]
    }
  }
) as SerializeFrom<typeof loader>['env']
